<template>
  <basic-card>
    <template slot="header">
      Cash-flow Effects
    </template>

    <simple-list object-name="cashEffect" query-store-name="cashEffect" :config="listConfig" :columns="columns"
                 @add="handleAdd"
                 @focusedChanged="handleFocusedChanged">
      <basic-card v-if="focusedEffect != null">
        <template #header>
          Cash-flow effect
        </template>
        <form-wrapper form-title="Cash-events">
          <form-text-input caption="Category" v-model="focusedEffect.category"/>
          <form-text-input caption="Name" v-model="focusedEffect.name"/>
        </form-wrapper>
        <form-wrapper form-title="Cash events removal">
          <form-checkbox-input v-model="focusedEffect.removeEventsFromReport" caption="Remove cash-events from cashflow"/>
        </form-wrapper>
        <framed-content title="Cash event decomposition" v-if="!focusedEffect.removeEventsFromReport">
        <form-wrapper>
          <form-checkbox-input v-model="focusedEffect.decomposeCashEvents" caption="Decompose cash-events"/>
        </form-wrapper>

        <template v-if="focusedEffect.decomposeCashEvents">
          <div v-for="cashEventDecomposer in focusedEffect.decompositionItems">
            <form-wrapper>
              <form-text-input caption="Date offset" v-model="cashEventDecomposer.dateOffset"/>
              <form-text-input caption="Ratio in %" v-model="cashEventDecomposer.ratio"/>
            </form-wrapper>
          </div>
          <info-box warning v-if="ratiosSum != 100">
            Sum of ratios is not equal to 100% ({{$formats.formatAmount(ratiosSum)}}%)
          </info-box>
          <simple-button @press="focusedEffect.decompositionItems.push({})">Add decomposition</simple-button>
        </template>
        </framed-content>

        <form-wrapper form-title="Other modifiers" v-if="!focusedEffect.removeEventsFromReport">
          <form-text-input v-model="focusedEffect.dateModifierExpression" caption="Date shift expression"/>
          <form-text-input v-model="focusedEffect.amountModifierExpression" caption="Amount change expression"/>
        </form-wrapper>

        <filter-form v-model="searchQuery" :filter-definition="cashEventQueryDefinition" :key="focusedEffect.id"/>
        <simple-button @press="saveEffect">
          <icon :icon="['fal', 'save']"/>&nbsp; Save
        </simple-button>
      </basic-card>

    </simple-list>

  </basic-card>
</template>

<script>
import BasicCard from "../components/layout/BasicCard";
import FilterForm from "../components/filters/FilterForm";
import QueryUtils from "../utils/QueryUtils";
import CollapsibleContent from "../components/CollapsibleContent";
import DataTable from "../components/table/DataTable";
import {mapGetters} from "vuex";
import SimpleButton from "../components/button/SimpleButton";
import Empty from "../components/layout/Empty";
import SimpleHorizontalLayout from "../components/layout/SimpleHorizontalLayout";
import FormWrapper from "../components/form/FormWrapper";
import FormSelectInput from "../components/form/FormSelectInput";
import FormTextInput from "../components/form/FormTextInput";
import SimpleList from "../components/lists/SimpleList";
import FramedContent from "../components/layout/FramedContent";
import FormCheckboxInput from "../components/form/FormCheckboxInput";
import InfoBox from "../components/InfoBox";

export default {
  name: "CashEventsView",
  components: {
    InfoBox,
    FormCheckboxInput,
    FramedContent,
    SimpleList,
    FormTextInput,
    FormSelectInput,
    FormWrapper,
    SimpleHorizontalLayout, Empty, SimpleButton, DataTable, CollapsibleContent, FilterForm, BasicCard
  },
  computed: {
    ...mapGetters({
      currencyOptions: "currencies/currenciesOptions",
      accountOptions: 'banking/accounts',
      parties: "parties/parties"
    }),
    cashEventQueryDefinition() {
      return QueryUtils.getByType("cashEvent", {currencies: this.currencyOptions, accounts: this.accountOptions, parties: this.parties.map(party => {
        return {id: party.id, name: party.displayName}
        })});
    },
    ratiosSum() {
      return this.focusedEffect.decompositionItems.reduce(((previousValue, currentValue) => previousValue += parseFloat(currentValue.ratio) ), 0);
    }
  },
  data() {
    return {
      focusedEffect: null,
      searchQuery: {
        id: "x",
        parameters: {}
      },
      listConfig: {
        tableConfiguration: {
          objectName: "Cash effects",
          enableAdd: true,
          allowEdit: true
        }
      },
      columns: [
        {
          caption: "Id",
          datum: d => d.id.substr(0, 5)
        },
        {
          caption: "Name",
          datum: d => d.name
        },
        {
          caption: "Category",
          datum: d => d.category ?? "N/A"
        }
      ]
    }
  },
  methods: {
    handleAdd() {
      this.searchQuery = {parameters: {

        }};

      this.focusedEffect = {
        searchQuery: {
          parameters: {

          }
        },
        decompositionItems: []
      };
    },
    handleFocusedChanged(item) {

      this.$set(this, 'searchQuery', {... item.searchQuery, id: "X"});
      this.$set(this, 'focusedEffect', item);





    },
    saveEffect() {
      this.focusedEffect.searchQuery = this.searchQuery;
      this.$store.dispatch("cashEffects/saveCashEffect", this.focusedEffect)
        .then(() => {
          this.$notify({
            group: 'application',
            title: 'Cash effect saved',
            text: `Cash effect successfully saved`,
            type: "ok"
          })
          this.focusedEffect = null
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/global.scss";

.add-modifier {
  &:hover {
    user-select: none;
    cursor: pointer;
    background-color: transparentize($openRed, 0.2);
  }
  background-color: transparentize($openRed, 0.5);
  border-radius: 3px;
  border: 1px dashed $openRed;
  padding: 5px;
}

.single-modifier {
  background-color: lighten($backgroundColor, 20);
}
</style>
